"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimePickerPropTypes = void 0;
var PropTypes = __importStar(require("prop-types"));
exports.TimePickerPropTypes = {
    disabled: PropTypes.bool,
    disabledTimes: PropTypes.array,
    format: PropTypes.string,
    id: PropTypes.string,
    label: PropTypes.string,
    max: PropTypes.string,
    min: PropTypes.string,
    menuPortalStyles: PropTypes.object,
    menuPortalTarget: PropTypes.instanceOf(HTMLElement),
    menuShouldBlockScroll: PropTypes.bool,
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onValidationChanged: PropTypes.func,
    placeholder: PropTypes.string,
    showRequired: PropTypes.bool,
    step: PropTypes.number,
    strict: PropTypes.bool,
    tooltip: PropTypes.string,
    tooltipCloseLabel: PropTypes.string,
    value: PropTypes.string,
};
